import React, {Component} from 'react';
import _ from 'lodash';
import {
    PanelGroup,
    Panel,
    Col,
    Badge,
    FormGroup,
    FormControl,
    Button,
    Modal,
    InputGroup
} from 'react-bootstrap';
import FormField from '../formField/FormField';
import Organogram from './organogram';
import ModalTitle from 'react-bootstrap/es/ModalTitle';
import ButtonGroup from 'react-bootstrap/es/ButtonGroup';
import HelpBlock from 'react-bootstrap/es/HelpBlock';
import NewRelatedParty from '../kyc/related/NewRelatedParty';
import ReactLoading from 'react-loading';
import Popup from '../Popup';
import validate from 'validate.js';
import Row from 'react-bootstrap/es/Row';
import ConfirmDelete from './ConfirmDelete';

const BUSINESS_TYPE = {
    naturalPerson: 'Natural Person',
    individual: 'Individual',
    juristicEntity: 'Juristic Entity'
};

export default class RelatedPartiesNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: null,
            newParty: false,
            errors: {},
            newRelatedPartyErrors: {},
            ogranShow: false,
            child: null,
            showOptions: false,
            newRP: {
                businessType: BUSINESS_TYPE.naturalPerson,
                supportingDocuments: [],
                new: true
            },
            loading: false,
            removing: false,
            removingRP: null,
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleNewRelatedParty = this.handleNewRelatedParty.bind(this);
        this.onRelatedPartyAddressUpdate = this.onRelatedPartyAddressUpdate.bind(this);
    }

    handleSelect(activeKey) {
        this.setState({activeKey});
    }

    handleCloseParty = () => {
        this.setState({newParty: false})
    };

    handleNewRelatedParty(form) {
        form.preventDefault();
        const {handleAddRelatedParty, handleAddOwner} = this.props;
        const newRelatedPartyErrors = {};
        const {target: {elements}} = form;
        const name = elements[0].value;
        const registrationNumber = elements[1].value;
        const phoneNumber = elements[2].value;
        const shareHoldingPercentage = elements[3].value;
        if (!name)
            newRelatedPartyErrors.name = 'error';
        if (!registrationNumber)
            newRelatedPartyErrors.registrationNumber = 'error';
        if (!phoneNumber)
            newRelatedPartyErrors.phoneNumber = 'error';
        if (!shareHoldingPercentage)
            newRelatedPartyErrors.shareHoldingPercentage = 'error';
        if (_.isEmpty(newRelatedPartyErrors)) {
            if (!this.state.child)
                handleAddRelatedParty({registrationNumber, phoneNumber, shareHoldingPercentage, name, new: true});
            else {
                const {child} = this.state;
                child.children ? child.children.push({
                    registrationNumber,
                    phoneNumber,
                    shareHoldingPercentage,
                    name,
                    new: true
                }) : child.children = [{registrationNumber, phoneNumber, shareHoldingPercentage, name, new: true}];
                let parent;
                do {
                    parent = this.buildMainUpdate(child);
                } while (parent.parent);
                handleAddOwner(parent);
            }
            this.setState({newRelatedPartyErrors, newParty: false, child: null})
        } else {
            this.setState({newRelatedPartyErrors})
        }
    }

    handleSelectChange = (event, attribute) => {

        this.setState({newRP: _.extend({}, this.state.newRP, {[attribute]: event.value})});

        console.info(this.state.newRP);
    };

    addDoc = (fileType, file) => {
        const {newRP} = this.state;
        const strippedBase64 = file.base64.split(',')[1];
        const doc = {
            documentId: strippedBase64,
            documentType: fileType,
            name: file.name,
            verified: true,
        };

        this.setState({
            newRP: _.extend({}, newRP, {
                supportingDocuments: _.union(newRP.supportingDocuments, [doc])
            })
        });
    };

    loadingStart = () => {
        this.setState({loading: true})
    };

    loadingFinish = () => {
        this.setState({loading: false})
    };

    onCancel = () => {
        const {actions} = this.props;
        actions.removeSearched();
        actions.clearIndiviualInfo();
        actions.clearEntityInfo();
        _.defer(() => this.setState({
            newParty: false,
            newRP: {businessType: BUSINESS_TYPE.naturalPerson, supportingDocuments: []},
            errors: {}
        }))
    };

    onChange = (event, attribute) => {
        let {target, target: {value}} = event;
        value = _.trimStart(value);
        if (target.type === 'number')
            value = parseInt(value, 10);
        const newRP = _.extend({}, this.state.newRP, {[attribute]: value});
        this.setState({newRP});
    };

    onIndividualSearch = (onComplete) => {
        this.setState({errors: {}});
        this.loadingStart();

        const onFinish = (finish, individual) => {
            let {newRP} = this.state;
            this.loadingFinish();
            newRP = {...newRP, ...individual};
            this.setState({newRP});
            onComplete && onComplete();
        };
        this.props.actions.fetchIndiviualInfo(this.state.newRP.registrationNumber, onFinish);
    };

    onEntitySearch = (onComplete) => {

        this.setState({errors: {}});
        this.loadingStart();
        const onFinish = (entity) => {
            this.loadingFinish();
            let {newRP} = this.state;
            this.loadingFinish();
            newRP = {...newRP, ...entity};
            this.setState({newRP});
            onComplete && onComplete();
            onComplete && onComplete();
        };
        this.props.actions.fetchEntityInfo(this.state.newRP.registrationNumber, onFinish);
    };

    resetError = (attribute) => {
        const {errors} = this.state;
        this.setState({errors: _.extend({}, errors, {[attribute]: null})})
    };

    onNewRPSubmit = () => {
        if (this.validateForm()) {

            const {handleAddRelatedParty, handleAddOwner} = this.props;
            const {newRP} = this.state;
            const isNaturalPerson = newRP.businessType === BUSINESS_TYPE.naturalPerson || newRP.businessType === BUSINESS_TYPE.individual;
            const {actions} = this.props;
            if (isNaturalPerson) {
                newRP.registeredName = `${newRP.registeredName} ${newRP.surname}`;
                newRP.firstName = newRP.registeredName;
                newRP.name = newRP.registeredName;
            }
            newRP.shareHoldingPercentage = newRP.sharePercentage;
            actions.clearIndiviualInfo();
            actions.clearEntityInfo();
            if (!this.state.child)
                handleAddRelatedParty(newRP);
            else {
                const {child} = this.state;
                child.children ? child.children.push({...newRP}) : child.children = [{...newRP}];
                let parent;
                do {
                    parent = this.buildMainUpdate(child);
                } while (parent.parent);
                handleAddOwner(parent);
            }
            _.defer(() => this.setState({
                addNewRP: false,
                newRP: {businessType: BUSINESS_TYPE.naturalPerson, supportingDocuments: []}
            }))
        }
    };

    validateForm = () => {
        const {newRP} = this.state;
        const options = {fullMessages: false};
        const isNaturalPerson = newRP.businessType === BUSINESS_TYPE.naturalPerson || newRP.businessType === BUSINESS_TYPE.individual;
        let constraints;
        if (!isNaturalPerson) {
            constraints = {
                registeredName: {presence: true, length: {minimum: 1, message: 'required'}},
                registrationNumber: {presence: true, length: {minimum: 1, message: 'required'}},
                contactNumber: {presence: true, length: {minimum: 1, message: 'required'}},
                sharePercentage: {
                    presence: true,
                    numericality: {greaterThan: 0, lessThanOrEqualTo: 100}
                },
                physicalAddress: {presence: true, length: {minimum: 1, message: 'required'}},
                headOfficeAddress: {presence: true, length: {minimum: 1, message: 'required'}},
                street: {presence: true, length: {minimum: 1, message: 'required'}}
            };
        } else {
            constraints = {
                registeredName: {presence: true, length: {minimum: 1, message: 'required'}},
                registrationNumber: {presence: true, length: {minimum: 1, message: 'required'}},
                contactNumber: {presence: true, length: {minimum: 1, message: 'required'}},
                sharePercentage: {
                    presence: true,
                    numericality: {greaterThan: 0, lessThanOrEqualTo: 100}
                },
                lastName: {presence: true, length: {minimum: 1, message: 'required'}},
                emailAddress: {presence: true, email: true, length: {minimum: 1, message: 'required'}},
                capacity: {presence: true, length: {minimum: 1, message: 'required'}}
            };
        }
        const errors = validate(newRP, constraints, options);

        this.setState({errors});
        return _.isEmpty(errors);
    };

    selectRPType = (event, selected) => {
        event.preventDefault();
        this.setState({newRP: {businessType: selected, supportingDocuments: []}, errors: {}});
    };

    buildMainUpdate(child) {
        const {parent} = child;
        const childId = _.findIndex(parent.children, (item) => item.goldTierId === child.goldTierId);
        parent.children[childId] = child;
        return parent;
    }

    onRelatedPartyAddressUpdate = ({target}, number) => {
        const {kycStructure, handleRelatedPartyAddressChange} = this.props;
        const relatedParty = kycStructure.children[number];
        const address = relatedParty.address ? relatedParty.address : {};
        const {name, value} = target;
        address[name] = value;
        handleRelatedPartyAddressChange(number, address);
    };

    handelOptions = (item) => {
        const {depth} = item;
        if (depth === 0) {
            this.setState({newParty: true, ogranShow: false, child: null});
        }
        if (depth >= 1) {
            this.setState({showOptions: true, ogranShow: false, child: item});
        }
    };

    onRemoveRP = (value) => {
        this.setState({removing: true, removingRP: value})
    }

    confirmRemove = () => {
        const {handleRemoveRelatedParty} = this.props;
        handleRemoveRelatedParty(this.state.removingRP);
        this.cancelRemove();
    }
    cancelRemove = () => {
        this.setState({removing: false, removingRP: null});
    }

    removeConfirm = () => {
        const {kycStructure: {children}} = this.props;
        const party = children[this.state.removingRP];
        const detail = `${party.name}`;

        return (
            <ConfirmDelete
                type={'Authorised Person'}
                confirmAction={this.confirmRemove}
                cancelAction={this.cancelRemove}
                detail={detail}
            />
        )
    }

    renderIndividual = (party, i) => {
        const {address} = party;
        return (
            <div>
                <Col md={6}>
                    <div className="section-title">
                        <span>Details</span>
                    </div>
                    <FormGroup
                    >
                        <label>Identity Number: <span className='text-danger'>*</span></label>
                        <FormControl
                            type="text"
                            value={party.idNumber}
                            disabled={true}
                            name='idNumber'
                            placeholder="Enter Identity Number"
                            onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                        />
                        <FormControl.Feedback/>
                    </FormGroup>
                    <FormGroup
                    >
                        <label>Telephone Number: <span
                            className='text-danger'>*</span></label>
                        <FormControl
                            type="text"
                            value={party.phoneNumber}
                            name='phoneNumber'
                            placeholder="Enter text"
                            onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                        />
                        <FormControl.Feedback/>
                    </FormGroup>
                    <FormGroup
                    >
                        <Row style={{marginLeft: 0, marginRight: 0}}>
                            <label>ShareHolding Percentage: <span
                                className='text-danger'>*</span></label>
                        </Row>
                        <InputGroup>
                            <FormControl
                                type="number"
                                value={party.shareHoldingPercentage}
                                name='shareHoldingPercentage'
                                placeholder="Enter Percentage"
                                onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                                min='0'
                                max='100'
                            />
                            <FormControl.Feedback/>
                            <InputGroup.Addon>%</InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <div className="section-title">
                        <span>Primary Address <span className='text-danger'>*</span></span>
                    </div>

                    <FormField className="form-group" id="regAddress">
                        <label htmlFor="registeredAddressLin1">Address</label>
                        <input
                            className="form-control"
                            id="registeredAddressLine1"
                            name='streetAddressLine1'
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                            type="text"
                            value={(address && address.streetAddressLine1) ? address.streetAddressLine1 : ""}

                        />
                    </FormField>

                    <FormField className="form-group" id="line2">
                        <label htmlFor="registeredAddressLine2">Suburb</label>
                        <input
                            className="form-control"
                            id="registeredAddressLine2"
                            name='suburb'
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                            type="text"
                            value={(address && address.suburb) ? address.suburb : ""}
                        />
                    </FormField>

                    <FormField className="form-group" id="regCity">
                        <label htmlFor="registeredCity">City</label>
                        <input
                            type="text"
                            className="form-control"
                            id="registeredCity"
                            name='crcCityId'
                            value={(address && address.crcCityId) ? address.crcCityId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regProvince">
                        <label htmlFor="stateOrProvince">State/Province</label>
                        <input
                            type="text"
                            className="form-control"
                            id="stateOrProvince"
                            name='crcRegionId'
                            value={(address && address.crcRegionId) ? address.crcRegionId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regPostalCode">
                        <label htmlFor="stateOrProvince">Zip/Postal Code</label>
                        <input
                            type="text"
                            className="form-control"
                            id="registoredZipOrPostalCode"
                            name='zipCode'
                            value={(address && address.zipCode) ? address.zipCode : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regCountry">
                        <label htmlFor="stateOrProvince">Country</label>
                        <input
                            type="text"
                            className="form-control"
                            id="country"
                            name='crcCountryId'
                            value={(address && address.crcCountryId) ? address.crcCountryId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>
                </Col>
            </div>
        );
    };
    renderJuristic = (party, i) => {
        const {address} = party;
        return (
            <div>
                <Col md={6}>
                    <div className="section-title">
                        <span>Details</span>
                    </div>
                    <FormGroup
                    >
                        <label>Registration Number: <span
                            className='text-danger'>*</span></label>
                        <FormControl
                            type="text"
                            value={party.registrationNumber}
                            name='registrationNumber'
                            placeholder="Enter text"
                            onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                        />
                    </FormGroup>
                    <FormGroup
                    >
                        <label>Telephone Number: <span
                            className='text-danger'>*</span></label>
                        <FormControl
                            type="text"
                            value={party.phoneNumber}
                            name='phoneNumber'
                            placeholder="Enter text"
                            onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                        />
                    </FormGroup>
                    <FormGroup
                    >
                        <Row style={{marginLeft: 0, marginRight: 0}}>
                            <label>ShareHolding Percentage: <span
                                className='text-danger'>*</span></label>
                        </Row>
                        <InputGroup>
                            <FormControl
                                type="number"
                                value={party.shareHoldingPercentage}
                                name='shareHoldingPercentage'
                                placeholder="Enter Percentage"
                                onChange={(e) => this.props.handleRelatedPartyChange(e, i)}
                                min='0'
                                max='100'
                            />
                            <InputGroup.Addon>%</InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <div className="section-title">
                        <span>Primary Address <span className='text-danger'>*</span></span>
                    </div>

                    <FormField className="form-group" id="regAddress">
                        <label htmlFor="registeredAddressLin1">Address</label>
                        <input
                            className="form-control"
                            id="registeredAddressLine1"
                            name='streetAddressLine1'
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                            type="text"
                            value={(address && address.streetAddressLine1) ? address.streetAddressLine1 : ""}

                        />
                    </FormField>

                    <FormField className="form-group" id="line2">
                        <label htmlFor="registeredAddressLine2">Suburb</label>
                        <input
                            className="form-control"
                            id="registeredAddressLine2"
                            name='suburb'
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                            type="text"
                            value={(address && address.suburb) ? address.suburb : ""}
                        />
                    </FormField>

                    <FormField className="form-group" id="regCity">
                        <label htmlFor="registeredCity">City</label>
                        <input
                            type="text"
                            className="form-control"
                            id="registeredCity"
                            name='crcCityId'
                            value={(address && address.crcCityId) ? address.crcCityId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regProvince">
                        <label htmlFor="stateOrProvince">State/Province</label>
                        <input
                            type="text"
                            className="form-control"
                            id="stateOrProvince"
                            name='crcRegionId'
                            value={(address && address.crcRegionId) ? address.crcRegionId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regPostalCode">
                        <label htmlFor="stateOrProvince">Zip/Postal Code</label>
                        <input
                            type="text"
                            className="form-control"
                            id="registoredZipOrPostalCode"
                            name='zipCode'
                            value={(address && address.zipCode) ? address.zipCode : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>

                    <FormField className="form-group" id="regCountry">
                        <label htmlFor="stateOrProvince">Country</label>
                        <input
                            type="text"
                            className="form-control"
                            id="country"
                            name='crcCountryId'
                            value={(address && address.crcCountryId) ? address.crcCountryId : ""}
                            onChange={(event) => {
                                this.onRelatedPartyAddressUpdate(event, i);
                            }}
                        />
                    </FormField>
                </Col>
            </div>
        );
    };

    renderRelatedParty = (party, i) => {
        const wellStyles = {maxWidth: 400, margin: '0 auto 10px'};
        return (
            <Panel eventKey={i} key={i} bsStyle="primary">
                <Panel.Heading>
                    <Panel.Title toggle>
                        <span className="caret"/><Badge>OPEN</Badge>&nbsp;
                        {party.name}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>

                    {
                        party.businessType === BUSINESS_TYPE.naturalPerson ||
                        party.businessType === BUSINESS_TYPE.individual
                            ? this.renderIndividual(party, i) : this.renderJuristic(party, i)
                    }
                    <Col md={12}>
                        <div className="btn-block" style={wellStyles}>
                            <Button bsStyle="primary" bsSize="large" block
                                    onClick={() => {
                                        this.props.handleSave();
                                        this.setState({activeKey: null});
                                    }}>
                                Save
                            </Button>
                            <Button bsStyle="danger" bsSize="large" block
                                    onClick={() => this.onRemoveRP(i)}>
                                Remove
                            </Button>
                        </div>
                    </Col>
                </Panel.Body>
            </Panel>
        )
    };


    renderOrgan = () => {
        return (
            <Modal show={this.state.ogranShow} bsSize="large" dialogClassName={'organModal'}
                   onHide={() => this.setState({ogranShow: false})}>
                <Modal.Body style={{height: '85vh'}}>
                    <Organogram entity={this.props.kycStructure} clickEvent={this.handelOptions}/>
                </Modal.Body>
                <Modal.Footer>
                    <HelpBlock>Click and drag with the mouse to move around.</HelpBlock>
                    <HelpBlock>Use the scroll wheel to zoom out.</HelpBlock>
                </Modal.Footer>
            </Modal>
        )
    };

    renderOptions = () => {
        const {child} = this.state;
        const back = () => {
            this.setState({showOptions: false, ogranShow: true})
        };
        if (child) {
            return (
                <Modal show={this.state.showOptions} onHide={() => this.setState({showOptions: false})}>
                    <Modal.Header>
                        <button type="button" className="close" onClick={back}><span aria-hidden="true">&lt; Back</span>
                        </button>
                        <ModalTitle>Options</ModalTitle>
                    </Modal.Header>
                    <Modal.Body>
                        <h3>{child.name}</h3>
                        <p>{`Registration Number: ${child.registrationNumber}`}</p>
                        <p>{`Phone Number: ${child.phoneNumber}`}</p>
                        <p>{`Share Holding Percentage: ${child.shareHoldingPercentage}`}</p>
                    </Modal.Body>
                    {
                        child.businessType !== "Individual" &&
                        <Modal.Footer>
                            <ButtonGroup>
                                <Button onClick={() => this.setState({newParty: true, showOptions: false})}>Add
                                    Owner</Button>
                            </ButtonGroup>
                        </Modal.Footer>
                    }
                </Modal>
            )
        } else {
            return false;
        }
    };

    render() {
        const {kycStructure} = this.props;
        const {errors, newParty} = this.state;
        return (
            <div>
                <PanelGroup
                    accordion
                    id="accordion-related-parties"
                    activeKey={this.state.activeKey}
                    onSelect={this.handleSelect}
                >
                    {kycStructure.children.map((party, i) => this.renderRelatedParty(party, i))}
                    <hr/>
                </PanelGroup>

                {
                    newParty &&
                    <Popup onClose={() => this.onCancel()}>
                        <NewRelatedParty
                            addDoc={this.addDoc}
                            errors={errors}
                            onCancel={this.onCancel}
                            onChange={this.onChange}
                            handleSelectChange={this.handleSelectChange}
                            onIndividualSearch={this.onIndividualSearch}
                            onEntitySearch={this.onEntitySearch}
                            onResetError={this.resetError}
                            onSubmit={this.onNewRPSubmit}
                            newRP={this.state.newRP}
                            selectRPType={this.selectRPType}
                        />
                        {
                            this.state.loading &&
                            <div className="inner-spinner-container">
                                <ReactLoading type="spokes" color="#444"/>
                            </div>
                        }
                    </Popup>
                }

                {
                    this.renderOrgan()
                }
                {
                    this.renderOptions()
                }
                {
                    this.state.removing && this.removeConfirm()
                }

                <Button onClick={() => this.setState({newParty: true})}>Add Related Party</Button>
                <Button onClick={() => this.setState({ogranShow: true})}>Show Organogram</Button>

            </div>
        )
    }

}